// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@material-ui/core';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

export const Container = styled.div<{selected: boolean}>`
  ${p =>
    p.selected &&
    css`
      box-shadow: 0 0 0 6px rgb(208, 225, 252);
    `}
`;

export const EditContainer = styled.div`
  background-color: ${globals.GRAY_TRANSPARENT};
  padding: 24px;
  margin-bottom: 24px;
`;

export const EditMessage = styled.div`
  font-style: italic;
  margin-bottom: 24px;
`;

export const EditAutocompleteContainer = styled.div`
  width: 300px;
`;

export const EditTextField = styled(TextField)``;

export const Banner = styled.div``;
